import {enableProdMode, LOCALE_ID, TRANSLATIONS, TRANSLATIONS_FORMAT} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import { of as ObservableOf } from 'rxjs/observable/of'
import {environment} from "./environments/environment";
import {getTranslationProviders, LocalizationHelper} from "common-angular-module";
import {Bootstrapper} from "./app/bootstrapper";
import {AppModule} from "./app/app.module";

if (environment.production) {
  enableProdMode();
}

const locale = document['angular2Portlet'].language as string;

let localization = "";
let providers = [];
let options = {};

getTranslationProviders(locale).then(res => {
  localization = res as string;
  localization = LocalizationHelper.mergeLocalization(localization, locale);
  providers = [
    {provide: TRANSLATIONS, useValue: localization},
    {provide: TRANSLATIONS_FORMAT, useValue: 'xlf'},
    {provide: LOCALE_ID, useValue: locale}
  ];
  options = {providers};
  Bootstrapper.bootstrap(document['angular2Portlet'].application, options);
  document["resourceBundle"] = LocalizationHelper.extractResourceBundleFromXML(localization);
}).catch(
  error => ObservableOf(console.error("Failed to load localization, default returned", error))
);

// UGLY HACK
let hackThis = false;
if (hackThis) {
  platformBrowserDynamic().bootstrapModule(AppModule);
}



// WEBPACK FOOTER //
// ./src/main.ts